module.exports = __webpack_public_path__ + "img/icon1.b464de92.png";